/**
 * Join two url path, avoiding double slash '/' with concatenation
 * @param first
 * @param second
 */

function join2UrlPaths(first: string, second: string = '/') {
  const parsed1 = first.endsWith("/") ? first.slice(0, -1) : first;
  const parsed2 = second.startsWith("/") ? second.substr(1) : second;
  return `${parsed1}/${parsed2}`;
}

export function joinUrlPath(first: string, ...rest: string[]) {
  return rest.reduce((curr, next) => join2UrlPaths(curr, next), first);
}
